import React, { Dispatch, SetStateAction } from 'react';

interface AgentSelectedType {
    agent_id:       number;
    username:       string;
    total_messages: string;
    sub_account:    string;
    status_table:   null;
    status:         string;
    login_time:     string;
    time_in_sesion: string;
}

interface FollowUpAgentsContextType {
    agentSelected: AgentSelectedType,
    setAgentSelected: Dispatch<SetStateAction<AgentSelectedType>>, 
}

export const FollowUpAgentsContext = React.createContext<FollowUpAgentsContextType>(null);